<template>
  <div class="static_page_view contact_page">
    <div class="page_card">
      <div class="contact_hero">
        <div class="contact_hero__icon">
          <i class="fas fa-headset"></i>
        </div>
        <div>
          <h1>{{ $t("STATIC_PAGES.contact") }}</h1>
          <p class="page_subtitle">{{ $t("STATIC_PAGES.contactSubtitle") }}</p>
        </div>
      </div>

      <social-contact-display />
    </div>
  </div>
</template>

<script>
import SocialContactDisplay from "@/components/general/SocialContactDisplay.vue";

export default {
  name: "ContactPage",

  components: {
    SocialContactDisplay,
  },
};
</script>

<style lang="scss" scoped>
.contact_page {
  .page_card {
    padding: 1.75rem;
  }
}

.contact_hero {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.75rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid var(--border_clr);

  h1 {
    margin-bottom: 0.35rem;
  }

  .page_subtitle {
    margin-bottom: 0;
  }

  &__icon {
    width: 56px;
    height: 56px;
    border-radius: 16px;
    background: var(--soft_main_theme_clr);
    color: var(--main_theme_clr);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1.4rem;
    flex-shrink: 0;
  }
}
</style>
